import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  signal,
  WritableSignal
} from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CredentialsDTO } from '../../application/models';
import { MODAL_TOKEN, ModalProvider, PresentModalComponent } from '@core';
import { ResetPasswordComponent } from '../reset-password/reset-password.component';
import { InputWithIconComponent } from '@ui-components';

@Component({
  selector: 'auth-form',
  templateUrl: './auth-form.component.html',
  styleUrls: ['./auth-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [IonicModule, ReactiveFormsModule, InputWithIconComponent]
})
export class AuthFormComponent {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);

  readonly isRegister: InputSignal<boolean> = input<boolean>(false);
  readonly actionEvent: OutputEmitterRef<CredentialsDTO> = output<CredentialsDTO>();

  readonly showPassword: WritableSignal<boolean> = signal<boolean>(false);
  readonly showPassword2: WritableSignal<boolean> = signal<boolean>(false);

  readonly credentialsForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required]),
    password2: new FormControl('')
  });

  constructor() {
    this.initializePasswordValidator();
  }

  onButtonClicked(): void {
    const credentials: CredentialsDTO = {
      email: this.credentialsForm.get('email')?.value,
      password: this.credentialsForm.get('password')?.value
    };

    if (this.isRegister() && !this.passwordMatchValidator()) {
      return this.passwordsNotMatched();
    }
    this.actionEvent.emit(credentials);
  }

  passwordMatchValidator(): boolean {
    if (!this.isRegister()) return true;
    const password: string = this.credentialsForm.get('password')?.value;
    const confirmPassword: string = this.credentialsForm.get('password2')?.value;
    return password === confirmPassword;
  }

  toggleShowPassword(): void {
    this.showPassword.update((value: boolean) => !value);
  }

  toggleShowPassword2(): void {
    this.showPassword2.update((value: boolean) => !value);
  }

  resetPasswordModal(): void {
    this.modalProvider.showModal$({
      component: ResetPasswordComponent,
      cssClass: 'present-modal'
    });
  }

  getTermsOfService(): void {
    window.open(
      'https://firebasestorage.googleapis.com/v0/b/orlikfy-infra-prod.appspot.com/o/docs%2FOrlikfy%20Regulamin.pdf?alt=media&token=337ce6fa-1b40-4ed9-a89d-4a917d332e91'
    );
  }

  getPolicyPrivacy(): void {
    window.open(
      'https://firebasestorage.googleapis.com/v0/b/orlikfy-infra-prod.appspot.com/o/docs%2FOrlikfy%20Polityka%20Prywatnosci.pdf?alt=media&token=ad93ba59-a2ef-445e-b4d2-5d75da613b9f'
    );
  }

  private initializePasswordValidator(): void {
    effect(() => {
      const password2: FormControl = this.credentialsForm.get('password2') as FormControl;
      password2.setValidators(this.isRegister() ? [Validators.required] : []);
      password2.updateValueAndValidity();
    });
  }

  private passwordsNotMatched(): void {
    this.modalProvider.showModal$({
      component: PresentModalComponent,
      componentProps: {
        header: 'Rejestracja',
        message: 'Hasła nie pasują',
        btnTxt: 'Zamknij'
      },
      cssClass: 'present-modal'
    });
  }
}
